import Image from "next/image";

export function HeroVisual() {
  return (
    <div className="relative mx-auto flex w-full justify-center lg:mx-0 lg:justify-start">
      <div className="relative w-full max-w-70 min-[400px]:max-w-75 sm:max-w-85 md:max-w-95 lg:max-w-110 xl:max-w-150 2xl:max-w-200">
        <Image
          src="/mobile-features-sm.svg"
          alt="NOMISS app preview on a phone showing sports digest and feature highlights"
          width={346}
          height={308}
          priority
          sizes="(max-width: 767px) 280px, 0px"
          className="relative z-1 block h-auto w-full drop-shadow-2xl md:hidden"
        />
        <Image
          src="/mobile-features.svg"
          alt="NOMISS app preview on a phone showing sports digest and feature highlights"
          width={650}
          height={633}
          priority
          sizes="(max-width: 1024px) 380px, (max-width: 1280px) 440px, 600px"
          className="relative z-1 hidden h-auto w-full drop-shadow-2xl md:block"
        />
      </div>
    </div>
  );
}
